<!-- MENUS -->
<!--div class="ion-padding about-saloon" style="padding-top:0px;">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.MENU.MENUS' | translate }}</h3>

  <div class="about-saloon__desc expanded" > 
    <p>blabla</p>
  </div>

</div-->

<!-- POPULAR DISHES -->
<div #popularDishes style="position: relative; top: -90px; left: 0"></div>
<div id="popular-dishes" class="ion-padding about-saloon" style="padding-top:10px;" *ngIf="popularDishesCategory && popularDishesCategory.children.length > 0">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.MENU.POPULAR_DISHES' | translate }}</h3>

  <app-popular-dishes [popularDishesCategory]="popularDishesCategory"></app-popular-dishes>

</div>

<!-- A LA CARTE -->
<div #aLaCarte style="position: relative; top: -100px; left: 0"></div>
<div id="a-la-carte" class="ion-padding about-saloon" style="padding-top:0px;" *ngIf="real?.suppliers">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.MENU.A_LA_CARTE' | translate }}</h3>

  <div class="about-saloon__desc expanded" style="white-space:pre-wrap;"> 
    <p class="formatted" [innerHtml]="real?.suppliers | ppTranslate:real?.suppliersTranslations:translateService.currentLang"></p>
    <!--<a class="dropdown-text">PREBERI VEČ
    <ion-icon class="dropdown"></ion-icon>
    </a>-->
  </div>

</div>

<!-- WINE LIST -->

<div #wineList style="position: relative; top: -100px; left: 0"></div>
<div id="wine-list" class="ion-padding about-saloon" style="padding-top:0px;" *ngIf="real?.wineList">
  <h3 class="about-saloon__title">{{ 'SHOP_DETAIL.MENU.WINE_LIST' | translate }}</h3>

  <div class="about-saloon__desc expanded" style="white-space:pre-wrap;"> 
    <p class="formatted" [innerHtml]="real?.wineList | ppTranslate:real?.wineListTranslations:translateService.currentLang"></p>
    <!--<a class="dropdown-text">PREBERI VEČ
    <ion-icon class="dropdown"></ion-icon>
    </a>-->
  </div>

</div>